export default __webpack_public_path__ + "static/media/big-cloud_2.3c1d4084.png";